interface Fee {
    method: string;
    percentFee: string;
    fixedFee: string;
    daysReleaseBalance: number;
    currency: string;
    country: string;
    securityReservePercent?: number;
    securityReserveDays?: number;
}

interface FeeDetailsProps {
    documentNumber: string;
    fees: Fee[];
}

export default function FeeDetails({
    fees = []
}: FeeDetailsProps) {
    // Encontrar taxas para cada método de pagamento
    const cardFee = fees.find(fee => fee.method === 'card' && fee.country === 'BR');
    const pixFee = fees.find(fee => fee.method === 'pix' && fee.country === 'BR');
    const boletoFee = fees.find(fee => fee.method === 'boleto' && fee.country === 'BR');

    // Encontrar taxas internacionais (qualquer país diferente de BR)
    const internationalFee = fees.find(fee => fee.country !== 'BR');
    return (
        <div className="space-y-8">
            {/* SEÇÃO 1: Detalhes */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {/* Texto da seção 1 */}
                <div className="md:col-span-1">
                    <h3 className="text-lg font-medium text-gray-800 dark:text-white">Vendas para o Brasil</h3>
                </div>

                {/* Card da seção 1 */}
                <div className="md:col-span-2">
                    <div className="bg-white dark:bg-white/[0.03] border border-gray-200 dark:border-gray-700 rounded-lg p-6 shadow-sm">
                        {/* Geral */}
                        <div className="mb-5">
                            <label className="mb-1 block text-sm text-gray-600 dark:text-gray-400">
                                Suas taxas:
                            </label>
                            <div className="flex items-center gap-2 mt-2">
                                <span className="text-gray-800 dark:text-gray-200">
                                    {cardFee ? `${cardFee.percentFee}% + R$ ${cardFee.fixedFee} por venda aprovada` : 'Não disponível'}
                                </span>
                            </div>
                        </div>
                        <div className="mb-5">
                            <label className="mb-1 block text-sm text-gray-600 dark:text-gray-400">
                                Prazo de recebimento:
                            </label>
                            <div className="flex items-center gap-2 mt-2">
                                <span className="text-gray-800 dark:text-gray-200">Cartão:</span>
                                <p className="text-gray-600 dark:text-gray-400">({cardFee ? `${cardFee.daysReleaseBalance} dias` : 'Não disponível'})</p>
                            </div>
                            <div className="flex items-center gap-2 mt-2">
                                <span className="text-gray-800 dark:text-gray-200">Pix:</span>
                                <p className="text-gray-600 dark:text-gray-400">({pixFee ? `${pixFee.daysReleaseBalance} dias` : 'Não disponível'})</p>
                            </div>
                            <div className="flex items-center gap-2 mt-2">
                                <span className="text-gray-800 dark:text-gray-200">Boleto:</span>
                                <p className="text-gray-600 dark:text-gray-400">({boletoFee ? `${boletoFee.daysReleaseBalance} dias` : 'Não disponível'})</p>
                            </div>
                        </div>

                        {/* Reserva de segurança */}
                        <div className="mb-5">
                            <label className="mb-1 block text-sm text-gray-600 dark:text-gray-400">
                                Reserva de segurança:
                            </label>
                            <div className="flex items-center gap-2 mt-2">
                                <span className="text-gray-800 dark:text-gray-200">5% por 30 dias</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Vendas Internacionais */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {/* Texto da seção 2 */}
                <div className="md:col-span-1">
                    <h3 className="text-lg font-medium text-gray-800 dark:text-white">Vendas internacionais</h3>
                </div>

                {/* Card da seção 2 */}
                <div className="md:col-span-2">
                    <div className="bg-white dark:bg-white/[0.03] border border-gray-200 dark:border-gray-700 rounded-lg p-6 shadow-sm">
                        {/* Geral */}
                        <div className="mb-5">
                            <label className="mb-1 block text-sm text-gray-600 dark:text-gray-400">
                                Suas taxas:
                            </label>
                            <div className="flex items-center gap-2 mt-2">
                                <span className="text-gray-800 dark:text-gray-200">
                                    {internationalFee ? `${internationalFee.percentFee}% + ${internationalFee.currency} ${internationalFee.fixedFee} por venda aprovada` : 'Não disponível'}
                                </span>
                            </div>
                        </div>
                        <div className="mb-5">
                            <label className="mb-1 block text-sm text-gray-600 dark:text-gray-400">
                                Prazo de recebimento:
                            </label>
                            <div className="flex items-center gap-2 mt-2">
                                <span className="text-gray-800 dark:text-gray-200">Cartão:</span>
                                <p className="text-gray-600 dark:text-gray-400">(30 dias)</p>
                            </div>
                        </div>

                        {/* Reserva de segurança */}
                        <div className="mb-5">
                            <label className="mb-1 block text-sm text-gray-600 dark:text-gray-400">
                                Reserva de segurança:
                            </label>
                            <div className="flex items-center gap-2 mt-2">
                                <span className="text-gray-800 dark:text-gray-200">10% por 45 dias</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
